import { Typography } from "@/components/common/ui/Typography";
import { cn } from "@/lib/utils/cn";
import type { EnvironmentBanner } from "@/lib/config/environment-banner";

const variants: Record<EnvironmentBanner, { label: string; classes: string }> = {
  staging: {
    label: "Staging environment",
    classes: "bg-[#F59E0B] text-[#451A03]",
  },
  local: {
    label: "Local environment",
    classes: "bg-[#7C3AED] text-white",
  },
};

export interface EnvironmentBannerViewProps {
  environment: EnvironmentBanner | null;
}

export function EnvironmentBannerView({ environment }: EnvironmentBannerViewProps) {
  if (!environment) return null;
  const { label, classes } = variants[environment];

  return (
    <div
      role="status"
      aria-label={label}
      className={cn(
        "flex h-7 w-full shrink-0 items-center justify-center gap-2.5 px-4",
        classes,
      )}
    >
      <span aria-hidden className="size-1.5 shrink-0 rounded-full bg-current" />
      <Typography variant="overline" color="inherit" weight="bold" tracking="tracking-[1px]">
        {label}
      </Typography>
    </div>
  );
}
